import { convictionStatus } from '@/constants/convictionStatus';
import dateFormatType from '@/constants/dateFormatType';
import AddressFormVM from '@/view-model/AddressFormVM';
import { format } from 'date-fns';
const dateFormat = dateFormatType.DATE;
// eslint-disable-next-line import/prefer-default-export
export const createWorkerFormData = () => ({
    // 라이더명
    name: '',
    // 사번
    hubEmployeeNumber: '',
    // 고용형태
    employeeType: 'SPECIAL',
    // 보수지급방식
    salaryType: 'PERFORMANCE_PAY',
    // 단말기번호
    phone: '',
    // 대상연락처
    telNumber: '',
    // 라이더 상태
    // useYn: '',
    // 근무시간
    workTime: {
        on: '00:00',
        off: '23:59',
    },
    // 주소
    addressFormData: new AddressFormVM({}),
    homeAddress: '',
    // 라이더 유형
    type: 'NORMAL_WORKER',
    // 입사일
    workerRegDate: format(new Date(), dateFormat),
    // 관리자메모
    memo: '',
    // 예치금
    depositBaromoney: 0,
    // 출금계좌 은행
    withdrawalBankCode: null,
    // 출금계좌 번호
    withdrawalBankAccount: '',
    // 출금계좌 예금주
    withdrawalBankOwner: '',
    // 주민등록번호
    socialNumber: '',
    // 차량번호
    carNumber: '',
    // 면허번호
    licenseNumber: '',
    // 단말기 유형
    cardDeviceType: 'NOT_EXIST',
    // 락타임
    orderDelayTimeSecond: 0,
    // 접수 목록 제한
    acceptedOrderViewLimitCount: 0,
    // 배차 제한잔액
    allocateLimitBaromoney: 0,
    // 최대 배차 가능 건수
    maxAllocateCount: 3,
    // 배차 후 완료가능 최소 시간
    minFinishMinuteAfterAllocated: 10,
    // GPS 활성화
    isForceGpsOn: true,
    // 공유배달 버튼
    isSharedOrderHidden: true,
    // 배차취소 권한
    isPossibleToCancelAllocatedOrder: false,
    // 픽업예상시간 수정 권한
    isImpossibleToChangePickupExpectedAt: false,
    // 도착지 주소 수정 권한
    isPossibleToChangeDropAddress: true,
    // 결제수단 변경 권한
    changePaymentAuthorityType: 'GRANTED',
    // // 관제 권한
    // isPossibleToControl: false,
    // // 상점 송금 권한
    // isPossibleToSendHubBaromoney: false,
    // 라이더 수수료 그룹
    workerDeliveryFeeGroupId: null,
    // 자동 차감 그룹
    workerCashAutoDeductGroupId: null,
    // 배차 취소 패널티 그룹
    workerPenaltyGroupId: null,
    // 결격여부
    convictionStatus: convictionStatus.DOCUMENT_NOT_SUBMITTED.key,
});
